import CaptchaSettings from '../captchaSettings';

class InvisibleRecaptchaFunctions {

    static scriptId = 'google-recaptcha-v3';
    static googleRecaptchaSrc = 'https://www.google.com/recaptcha/api.js';

    static execute(verifyCallback) {
        if (document.getElementById(this.scriptId)) {
            console.info('Fallback recaptcha scriptId found');
            this.handleOnLoad(verifyCallback);
        } else {
            console.info('Fallback recaptcha inject script');
            const head = document.getElementsByTagName('head')[0];

            const js = document.createElement('script');
            js.id = this.scriptId;
            js.src = `${this.googleRecaptchaSrc}?render=${CaptchaSettings.recapctha}`;
            js.onload = this.handleOnLoad(verifyCallback);

            window.onloadCallback = () => {
                this.handleOnLoad(verifyCallback)
            };

            head.appendChild(js);
        }
    };

    static handleOnLoad(verifyCallback) {
        console.info('Fallback recaptcha handleOnLoad');
        if (!window.grecaptcha) {
            console.info('Fallback recaptcha is not available: setup timeout retry');
            setTimeout(() => {this.handleOnLoad(verifyCallback)}, 1000);
        } else {
            console.info('Fallback recaptcha before ready');
            window.grecaptcha.ready(function() {
                console.info('Fallback recaptcha before execute');
                window.grecaptcha.execute(CaptchaSettings.recapctha, {action: 'submit'}).then(function(token) {
                    console.info('Fallback recaptcha before call verifyCallback');
                    verifyCallback(token)
                });
            });
        }
    };

}
export default InvisibleRecaptchaFunctions;